import { validateNumber } from 'ember-changeset-validations/validators';

export default {
  askAmount: validateNumber({
    gt: 0,
    integer: true,
    allowBlank: false,
    message: 'Must be a positive whole number',
  }),
};
